;(function (angular, _) {
  'use strict'

  angular
    .module('kilo.routes.invoice.show')
    .controller('SelectProduct', SelectProduct)

  SelectProduct.$inject = [
    // Angular
    '$uibModalInstance',

    // Managers
    'ProductManager',

    // Services
    'PreferencesService',

    // Resolved
    'interventions', 'stocks'

  ]

  function SelectProduct (
    // Angular
    $uibModalInstance,

    // Managers
    ProductManager,

    // Services
    PreferencesService,

    // Resolved
    interventions, stocks

  ) {
    const self = this
    self.$onInit = () => {
      _.extend(self, {
        searchProducts: searchProducts,
        cancel: cancel,
        ok: ok,
        interventions: interventions,
        stocks: stocks,
        sum: true
      })
      init()
    }

    function init() {
      if (self.stocks) {
        // reassemble stocks that comme from several warehouses or interventions
        self.stocks = _.reduce(self.stocks, function (acc, stock) {
          var existing = _.find(acc, function (compare) {
            return _.get(compare, 'stock.product._id') === stock.stock.product._id
          })
          if (existing) {
            existing.quantity = existing.quantity + stock.quantity
            // keep a trace of the original stock to mark it invoiced
            existing.comeFrom.push({ intervention: stock.intervention, stock: stock.stock._id })
          } else {
            // keep a trace of the original stock to mark it invoiced
            stock.comeFrom = [{ intervention: stock.intervention, stock: stock.stock._id }]
            acc.push(stock)
          }
          return acc
        }, [])

      }
    }

    function ok () {
      $uibModalInstance.close({
        sum: self.sum,
        travel: self.travel,
        product: self.product,
        productTravel: self.productTravel,
        stocks: self.stocks
      })
    }

    function searchProducts (query) {
      return ProductManager.get(
        ProductManager
          .query({
            conditions: JSON.stringify({
              'flags': 'sufa',
              $or: [{
                label: {
                  $regex: query,
                  $options: 'i'
                }
              },
              {
                reference: {
                  $regex: query,
                  $options: 'i'
                }
              }]
            })
          })
          .limit(10))
        .then(function (result) {
          return result.data
        })
    }

    function cancel () {
      $uibModalInstance.dismiss()
    }
  }
})(window.angular, window._)
